module.exports = __webpack_public_path__ + "8e2aad287a0b3284d3b1185306dda9b9.svg";